import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import {
  BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
  BuildingMultiSelect,
  BuildingSelectFormikField,
} from '../../../../../../../Building'
import { FieldStackedLabel } from '../../../../../../../Field'
import { ALL_BUILDINGS_COUNT } from '../../../../../NewsboardPostForm.constants'
import { NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING } from '../../../RecipientsField.constants'

function BuildingFields({ disabled }) {
  const { t } = useTranslation()
  const selectStatesRef = useRef(null)

  const { setFieldValue } = useFormikContext()

  function handleChange() {
    if (!selectStatesRef.current.searchValue) {
      setFieldValue(ALL_BUILDINGS_COUNT, selectStatesRef.current?.totalCount)
    }
  }

  return (
    <>
      <BuildingSelectFormikField
        multi
        Field={FieldStackedLabel}
        Select={BuildingMultiSelect}
        apiParams={BUILDING_OPTIONS_WITH_AVATAR_PARAMS}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t('Newsboard.RecipientsBuildingPlaceholderKey'),
            },
          },
        }}
        disabled={disabled}
        fieldComponentProps={{
          disabled,
          label: t('Newsboard.RecipientsBuildingLabelKey'),
        }}
        name={NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING}
        selectStatesRef={selectStatesRef}
        onChange={handleChange}
      />
    </>
  )
}

export default BuildingFields
